module.exports = __webpack_public_path__ + "static/media/youtube-white.17482412.svg";